import { AXIOSWAYS, ApiInfo } from './server';
import Wx from 'weixin-js-sdk';

export default {
    Attribute: {
        UA: window.navigator.userAgent,
        // 判断是否是微信
        isWeixin () {
            var ua = this.UA
            if (/MicroMessenger/i.test(ua)) {
                return true
            }
            return false
        },
        // 判断是否是QQ
        isQQ () {
            var ua = this.UA
            if (/QQ\//.test(ua)) {
                return true
            }
            return false
        },
        // 判断是否是Android
        isAndroid () {
            var ua = this.UA
            if (/android/i.test(ua)) {
                return true
            }
            return false
        },
        // 判断是否是ios
		isIOS (){
			var ua = this.UA;
		    if (/ios/i.test(ua) || /iphone/i.test(ua) || /ipad/i.test(ua) || /ipod/i.test(ua)) {
		       return true;
		    }
		    return false;
        },
        isIosMQQBrowser () {
            var ua = this.UA;
            if (this.isIOS() && /MQQBrowser/.test(ua)) {
                return true;
            }
            return false;
        },
        // 判断是否是手机
        isMb() {
            var ua = this.UA
            if (/Android|webOS|iPhone|iPod|BlackBerry|Windows Phone/i.test(ua)) {
                return true
            }
            return false
        },
        isIpad () {
            var ua = this.UA
            if (/ipad/i.test(ua)) {
                return true;
             }
             return false;
        }
    },
    // 分享
    // pageShare () {
    //     Api.getHomeShare({}).then((data) => {
    //         data && data.share && this.onshare({
    //             shareTitle: data.share.shareTitle,
    //             shareBrief: data.share.shareBrief,
    //             shareImg: data.share.shareImg,
    //             shareUrl: window.location.href
    //         })
    //     })
    // },
    // 分享
    onShare (obj) {
        const shareDate = {
            title: obj.shareTitle ? obj.shareTitle : '川渝互联网联动辟谣平台',
            desc: obj.shareBrief ? obj.shareBrief : '川渝互联网联动辟谣平台' ,
            imgUrl: obj.shareImg ? obj.shareImg : 'https://wapcdn.thecover.cn/cdn/cover_pc/static/img/2x/cy_piyao_share_logo.png',
            link: obj.shareUrl ? obj.shareUrl : window.location.href,
        }
        // 微信分享
        if (this.Attribute.isWeixin()) {
            this.setWeChatConf().then(() => {
                this.wxOnshare(shareDate)
            })
        // qq分享
        } 
        else if (this.Attribute.isQQ()) {
            if (window.mqq && window.mqq.data && window.mqq.data.setShareInfo) { // 手机qq内置浏览器
                window.mqq.data.setShareInfo({
                    title: shareDate.title,
                    share_url: shareDate.link,
                    image_url: shareDate.imgUrl,
                    desc: shareDate.desc
                })
            } else {
                this.loadjs('https://open.mobile.qq.com/sdk/qqapi.js?_bid=152').then(() => { // qq浏览器
                    window.mqq.data.setShareInfo({
                        title: shareDate.title,
                        share_url: shareDate.link,
                        image_url: shareDate.imgUrl,
                        desc: shareDate.desc
                    })
                })
            }
        }
    },
    // 微信配置
    setWeChatConf () {
        return new Promise((resolve, reject) => {
            AXIOSWAYS.post(
                ApiInfo.getWeChatConf,
                {
                    url: window.location.href
                }
            ).then(data => {
                const D = data
                Wx.config({
                    debug: false,
                    appId: D.appId,
                    timestamp: D.timestamp,
                    nonceStr: D.nonceStr,
                    signature: D.signature,
                    jsApiList: [
                        'onMenuShareTimeline',
                        'onMenuShareAppMessage',
                        'onMenuShareQQ',
                        'onMenuShareWeibo',
                        'onMenuShareQZone',
                        'previewImage'
                    ]
                })
                resolve()
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 微信分享
    wxOnshare (obj) {
        Wx.ready(() => {
            // 分享到朋友圈
            Wx.onMenuShareTimeline(obj)
            // 分享给朋友
            Wx.onMenuShareAppMessage(obj)
            // 分享到QQ
            Wx.onMenuShareQQ(obj)
            // 分享到腾讯微博
            Wx.onMenuShareWeibo(obj)
            // 分享到QQ空间
            Wx.onMenuShareQZone(obj)
        })
    },
    // 动态加载js
    loadjs (src) {
        return new Promise((resolve, reject) => {
            const scriptNode = document.createElement('script')
            scriptNode.setAttribute('type', 'text/javascript')
            scriptNode.setAttribute('src', src)
            document.body.appendChild(scriptNode)
            // IE 判断
            if (scriptNode.readyState) {
                scriptNode.onreadystatechange = () => {
                    if (scriptNode.readyState === 'complete' || scriptNode.readyState === 'loaded') {
                        resolve()
                    }
                }
            } else {
                scriptNode.onload = () => {
                    resolve()
                }
            }
        })
    },
    loadScroll(height, fn) {
        // height-判定的高度 fn-执行的回调函数
        window.addEventListener('scroll', function() {
            if(Math.ceil((document.body.scrollTop || document.documentElement.scrollTop))
              + (window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight)
              >= (document.documentElement.scrollHeight || document.body.scrollHeight) - height
            ) {
                fn();
            }
        }, false)
    },
    initFontSize () {
        if(this.Attribute.isMb()) {
            return;
        }
        const screenWidth = document.documentElement.clientWidth;
        const fontRatio = 1480 / 16;
        document.querySelector('html').style.fontSize = screenWidth / fontRatio + 'px';
    },
    watchFontSize () {
        if(this.Attribute.isMb()) {
            return;
        }
        window.addEventListener('resize', () => {
            this.initFontSize();
        })
    },
    // 给id加密解密
    Base64: {
        // private property
        _keyStr: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",

        // public method for encoding
        encode: function (input) {
            let output = "";
            let chr1, chr2, chr3, enc1, enc2, enc3, enc4;
            let i = 0;

            input = this._utf8_encode(input);

            while (i < input.length) {

                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output = output +
                    this._keyStr.charAt(enc1) + this._keyStr.charAt(enc2) +
                    this._keyStr.charAt(enc3) + this._keyStr.charAt(enc4);

            }

            return output;
        },

        // public method for decoding
        decode: function (input) {
            let output = "";
            let chr1, chr2, chr3;
            let enc1, enc2, enc3, enc4;
            let i = 0;

            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");

            while (i < input.length) {

                enc1 = this._keyStr.indexOf(input.charAt(i++));
                enc2 = this._keyStr.indexOf(input.charAt(i++));
                enc3 = this._keyStr.indexOf(input.charAt(i++));
                enc4 = this._keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 != 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 != 64) {
                    output = output + String.fromCharCode(chr3);
                }

            }

            output = this._utf8_decode(output);

            if(!/^\d+$/.test(output)) {
                return ''
            }

            return output;

        },

        // private method for UTF-8 encoding
        _utf8_encode: function (string) {
            string = String(string);
            string = string.replace(/\r\n/g, "\n");
            let utftext = "";

            for (let n = 0; n < string.length; n++) {

                const c = string.charCodeAt(n);

                if (c < 128) {
                    utftext += String.fromCharCode(c);
                } else if ((c > 127) && (c < 2048)) {
                    utftext += String.fromCharCode((c >> 6) | 192);
                    utftext += String.fromCharCode((c & 63) | 128);
                } else {
                    utftext += String.fromCharCode((c >> 12) | 224);
                    utftext += String.fromCharCode(((c >> 6) & 63) | 128);
                    utftext += String.fromCharCode((c & 63) | 128);
                }

            }

            return utftext;
        },

        // private method for UTF-8 decoding
        _utf8_decode: function (utftext) {
            let string = "";
            let i = 0;
            let c = 0;
            let c1 = 0;
            let c2 = 0;
            let c3 = 0;

            while (i < utftext.length) {

                c = utftext.charCodeAt(i);

                if (c < 128) {
                    string += String.fromCharCode(c);
                    i++;
                } else if ((c > 191) && (c < 224)) {
                    c2 = utftext.charCodeAt(i + 1);
                    string += String.fromCharCode(((c & 31) << 6) | (c2 & 63));
                    i += 2;
                } else {
                    c2 = utftext.charCodeAt(i + 1);
                    c3 = utftext.charCodeAt(i + 2);
                    string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
                    i += 3;
                }

            }

            return string;
        }
    },
}